// extracted by mini-css-extract-plugin
export default {"departmentsSelector":"AKuYbYI93DO2zrjTaRR7","rtl":"WRar7Ddo7Uep_hOEQO3l","color":"xBuuk1JtuPfkptwlBqDm","option":"TYA2qZ5UJLO6zfiM3HF_"};